import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/bands";

class BandDashboardService {
  // Band Analytics
  getBandAnalytics = async (bandId) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/analytics`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching band analytics.");
    }
  };

  getBandProductAnalytics = async (bandId) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/product-analytics`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching band product analytics."
      );
    }
  };

  // Band Products
  getBandProducts = async (bandId, params = {}) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/products`,
        { params }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching band products.");
    }
  };

  // Band Orders
  getBandOrders = async (bandId, params = {}) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/orders`,
        { params }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching band orders.");
    }
  };

  // Band Monthly Revenues
  getBandMonthlyRevenues = async (bandId) => {
    try {
      const response = await axiosApiClient.get(`revenue/monthly/${bandId}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching band monthly revenues."
      );
    }
  };

  getMonthlyBandRevenuesByPeriod = async ({
    bandId,
    startYear,
    startMonth,
    endYear,
    endMonth,
  }) => {
    try {
      const response = await axiosApiClient.get(
        `revenue/monthly/${bandId}/period?startYear=${startYear}&startMonth=${startMonth}&endYear=${endYear}&endMonth=${endMonth}`
      );

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching monthly band revenues by period."
      );
    }
  };
}

const bandDashboardService = new BandDashboardService();
export default bandDashboardService;
